import { render, staticRenderFns } from "./InputUploadImg.vue?vue&type=template&id=2b6cb2f2&scoped=true&"
import script from "./InputUploadImg.vue?vue&type=script&lang=js&"
export * from "./InputUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./InputUploadImg.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InputUploadImg.vue?vue&type=style&index=1&id=2b6cb2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6cb2f2",
  null
  
)

export default component.exports